import { render, staticRenderFns } from "./AddinForm.vue?vue&type=template&id=158f0460&lang=pug&"
import script from "./AddinForm.vue?vue&type=script&lang=ts&"
export * from "./AddinForm.vue?vue&type=script&lang=ts&"
import style0 from "./AddinForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports